<template>
	<div id="app">
		<!-- <div id="refreshAlertModel" class="alert-modal">
			<div class="modal-content">
				<div style="text-align: right;">
					<span class="close" @click="closeAlertBox">
						&times;
					</span>
				</div>
				<div style="text-align: center;">
					<p>Your Session has been Expired, Please Login to Continue.</p>
					<button class="ok-btn" @click="globalLogout">
						OK
					</button>
				</div>
			</div>
		</div> -->
		<router-view />

		<!-- <div v-if="accept_cookies_confirmation_box_visible" class="cookies-confirmation">
			<p>We use cookies to recognize your preferences and for delivering the best browsing experience. </br> By continuing to use our site, you agree to accept our <span target="_blank" @click="() => $router.push({ name: 'Privacy&policy' })">Privacy Policy</span></p>
			<div class="confirmation-btns mt-2">
				<el-button size="mini" class="accept-btn" @click="setCookieForCookiesConfirmationDailog()">I Accept</el-button>
				<el-button size="mini" class="decline-btn" @click="accept_cookies_confirmation_box_visible = false;">I Decline</el-button>
			</div>
		</div> -->
	</div>
</template>
<script>
import { serverAddr } from "../src/networkConfig";
import { EventBus } from "./eventBus";
import moment from "moment";
export default {
  data() {
    return {
      accept_cookies_confirmation_box_visible: false,
    };
  },
  mounted() {
     // Check user is authorized or now
    // this.isUserAuthorized();
    if (
        localStorage.getItem('x-refresh-token') &&
        this.$router.currentRoute.path != "/about-us" &&
        this.$router.currentRoute.path != "/ai-forecasting-and-reco-engine" &&
        this.$router.currentRoute.path != "/workforce-scheduling" &&
        this.$router.currentRoute.path != "/request-demo" &&
        this.$router.currentRoute.path != "/account-setting-nav-bar" &&
        this.$router.currentRoute.path != "/terms-of-service" &&
        this.$router.currentRoute.path != "/privacy-policy" &&
        this.$router.currentRoute.path != "/demand-planning"
      ) {
        // Check user is authorized or now
		    this.isUserAuthorized();
      }
    //if user has not accepted cookies policy then displyaed confirmation dialog
    //if cookie is available then displayed other wise not
    if (!this.getCookieForCookiesConfirmationDailog()) {
      this.accept_cookies_confirmation_box_visible = true;
    }

    setInterval(() => {
      // restricted function call on presign in pages
      if (
        this.$router.currentRoute.path != "/" &&
        this.$router.currentRoute.path != "/about-us" &&
        this.$router.currentRoute.path != "/ai-forecasting-and-reco-engine" &&
        this.$router.currentRoute.path != "/workforce-scheduling" &&
        this.$router.currentRoute.path != "/request-demo" &&
        this.$router.currentRoute.path != "/account-setting-nav-bar" &&
        this.$router.currentRoute.path != "/terms-of-service" &&
        this.$router.currentRoute.path != "/privacy-policy" &&
        this.$router.currentRoute.path != "/demand-planning"
      ) {
        function parseJwt(token) {
          var base64Url = token.split(".")[1];
          var base64 = base64Url.replace("-", "+").replace("_", "/");
          return JSON.parse(window.atob(base64));
        }

        var refresh_token = JSON.parse(
          window.localStorage.getItem("x-refresh-token")
        );

        serverAddr
          .post("/users/login/refresh/", {
            refresh: refresh_token,
          })
          .then(function (response) {
            // console.log("response in app.vue", response.data.access);
            if (response.data.access) {
              window.localStorage.removeItem("x-access-token");
              window.localStorage.setItem(
                "x-access-token",
                JSON.stringify(response.data.access)
              );
            }
          })
          .catch((e) => {
            console.error(e);
            let errorStatus = e.response.status;
            if (
              this.$router.currentRoute.path != "/" &&
              this.$router.currentRoute.path != "/about-us" &&
              this.$router.currentRoute.path !=
                "/ai-forecasting-and-reco-engine" &&
              this.$router.currentRoute.path != "/workforce-scheduling" &&
              this.$router.currentRoute.path != "/request-demo" &&
              this.$router.currentRoute.path != "/account-setting-nav-bar" &&
              this.$router.currentRoute.path != "/terms-of-service" &&
              this.$router.currentRoute.path != "/privacy-policy" &&
              this.$router.currentRoute.path != "/demand-planning" &&
              errorStatus > 400
            ) {
              //displayd dialog if not root route (landing) page
              document.getElementById("refreshAlertModel").style.display = "block";
              this.globalLogout();
            }
          });
      }
      //  I will run for every 30 minutes
    }, 30 * 60 * 1000);
  },
  methods: {
    globalLogout() {
      EventBus.$emit('logout_user', true);
    },
    //set cookie to avoid accept cookies dialog
    setCookieForCookiesConfirmationDailog() {
      var d = new Date();
      d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie =
        "isCookiesAccepted" + "=" + true + ";" + expires + ";path=/";

      this.accept_cookies_confirmation_box_visible = false;
    },

    isUserAuthorized(){
			serverAddr
				.get("/users/self/", {})
				.then(res => {
					 if(res.status == 401) {
						const r_email = localStorage.getItem('r_email');
            localStorage.clear();
            if(r_email){
              localStorage.setItem('r_email', r_email);
            }
            this.$router.push({path:'/'}).catch(()=>{});
					 }
				})
				.catch(error => {
					if(error.response.status == 401) {
						const r_email = localStorage.getItem('r_email');
            localStorage.clear();
            if(r_email){
              localStorage.setItem('r_email', r_email);
            }
						this.$router.push({path:'/login'}).catch(()=>{});
					}
				}).finally(()=>{
          let session = localStorage.getItem('session_expiration_time');
          if(session) {
            let diff = moment().diff(moment(session), 'h');
            if(diff >= 6) {
              const r_email = localStorage.getItem('r_email');
              localStorage.clear();
              if(r_email){
                localStorage.setItem('r_email', r_email);
              }
              this.$router.push({path:'/login'}).catch(()=>{});
            }
          } else {
            const r_email = localStorage.getItem('r_email');
            localStorage.clear();
            if(r_email){
              localStorage.setItem('r_email', r_email);
            }
            this.$router.push({path:'/login'}).catch(()=>{});
          }
        });
		},

    //get cookie to check that user has seen cookies dialog or not
    getCookieForCookiesConfirmationDailog() {
      const cookieValue = document.cookie
        .split("; ")
        .find((row) => row.startsWith("isCookiesAccepted"));
      if (cookieValue) {
        cookieValue.split("=")[1];
        return cookieValue;
      }

      return false;
    },
    closeAlertBox() {
      this.globalLogout();
      document.getElementById("refreshAlertModel").style.display = "none";
    },
    openLoginModel() {
      document.getElementById("refreshAlertModel").style.display = "none";
      window.localStorage.setItem("x-access-token", null);
      window.localStorage.setItem("x-refresh-token", null);
      this.$router.push({ name: "Home" }).catch(()=>{});
      window.location.reload();
      // this.$store.commit("openLoginModel", true);
    },
  },
};
</script>
<style lang="scss">
@import "../src/assets/css/variable.scss";
@import "../src/assets/css/ns-styles.scss";
@import url("../src/assets/css/tailwind.css");
// @import url("https://fonts.googleapis.com/css?family=Raleway");
/* @font-face {
	font-family: "karla";
	src: url("./assets/fonts/Karla/Karla-Regular.ttf");
}
@font-face {
	font-family: "karla-bold";
	src: url("./assets/fonts/Karla/Karla-Bold.ttf");
} */
// @font-face {
//   font-family: 'Roboto';
//   font-style: normal;
//   font-weight: 300;
//   src: url('./assets/fonts/Roboto_Slab/RobotoSlab-VariableFont_wght.ttf'); /* IE9 Compat Modes */
// //   src: local('Montserrat Light'), local('Montserrat-Light'),
// //        url('./assets/font/montserrat1/montserrat-v14-latin-300.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
// //        url('./assets/font/montserrat1/montserrat-v14-latin-300.woff2') format('woff2'), /* Super Modern Browsers */
// //        url('./assets/font/montserrat1/montserrat-v14-latin-300.woff') format('woff'), /* Modern Browsers */
// //        url('./assets/font/montserrat1/montserrat-v14-latin-300.ttf') format('truetype'), /* Safari, Android, iOS */
// //        url('./assets/font/montserrat1/montserrat-v14-latin-300.svg#Montserrat') format('svg'); /* Legacy iOS */
// }
.primary-theme-color {
  color: $primary-theme-color;
}
body {
  /* font-family: "karla"; */
  // font-family: "Raleway", sans-serif;
  font-family: "Open Sans", sans-serif;
  word-break: normal !important;
  // font-family: "Roboto", sans-serif;
  // font-family: "Avenir", Helvetica, Arial, sans-serif;
}
.loaderImage {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -25px;
  margin-left: -25px;
  width: 50px;
  height: 50px;
  z-index: 501;
}
.homepage-loader {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 500;
}

.input-label {
  margin: 2px 0 5px;
  color: #5f5f5f;
  font-size: 0.75rem;
  font-weight: 700;
}
.input-box {
  margin-right: 20px;
}
.box-220 {
  width: 220px;
}
.box-250 {
  width: 250px;
}
.box-300 {
  width: 300px;
}
.orng-btn {
  min-width: 110px !important;
}
.event-table {
  // margin-top: 20px;
  // height: 420px;
  * {
    text-transform: capitalize;
  }

  table {
    width: 100%;
    margin: 0 auto 10px;
    // border: 1px solid #dedede;
    text-align: left;
    border-left: none;
    border-right: none;

    thead {
      background-color: #f7f6f6;
    }

    tr {
      // border-bottom: 1px solid #dddddd;
    }

    th {
      padding: 22px 12px;
      letter-spacing: 0px;
      color: #1d1c1c;
      // border-bottom: 1px solid #bfbfbf;
      text-transform: uppercase;
      font-size: 11px;
      width: 15.33%;
      font-weight: 700;
    }

    td {
      padding: 17px 12px;
      font-size: 12px;
      letter-spacing: 0px;
      color: #707070;
      // border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
      width: 15.33%;

      img {
        cursor: pointer;
      }

      &:first-child {
        // text-align: left;
      }
    }

    tbody {
      display: block;
      height: 300px;
      overflow-y: auto;
    }

    thead,
    tbody tr {
      display: table;
      width: 100%;
      table-layout: fixed;
      /* even columns width , fix width of table too*/
    }

    thead {
      // width: calc( 100% - 1em )/* scrollbar is average 1em/16px width, remove it from thead width */
    }

    tbody tr:hover {
      background-color: #edf3f8;
    }
  }
}

.alert-modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 3; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  z-index: 112;
}

/* Modal Content/Box */
.alert-modal .modal-content {
  background-color: #fefefe;
  margin: 0 auto; /* 15% from the top and centered */
  padding: 20px;
  border: 1px solid #888;
  width: 60%; /* Could be more or less, depending on screen size */
}

/* The Close Button */
.alert-modal .close {
  color: #aaa;
  font-size: 28px;
  font-weight: bold;
}

.alert-modal .close:hover,
.alert-modal .close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.alert-modal .ok-btn {
  margin-top: 20px;
  border: 1px solid $orange-bg-button-color;
  background-color: $orange-bg-button-color;
  text-align: center;
  border-radius: 2px;
  cursor: pointer;
  letter-spacing: 0.02em;
  transition: all 0.2s ease;
  color: #fff;
  width: 100px;
  height: 30px;
}

// custom checkbox css of element-ui
.el-checkbox.is-bordered.is-checked {
  border-color: #8fa7e1 !important;
}
.el-checkbox__inner:hover {
  border-color: #8fa7e1 !important;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #505050 !important;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #8fa7e1 !important;
  border-color: #8fa7e1 !important;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  // background-color: #8fa7e1 !important;
  border-color: #8fa7e1 !important;
}
.el-checkbox.is-bordered.el-checkbox--medium {
  padding: 10px 20px 7px 10px !important;
  border-radius: 4px;
  height: 36px;
}
 .el-checkbox__label {
    text-transform: capitalize !important;
  }
// added custom css in el-imput
.el-input__inner::placeholder {
  color: $input-placeholder-color !important;
}
.el-input__inner:focus,
.el-select .el-input__inner:focus {
  border: $input-border-focus !important;
}
.el-select .el-input.is-focus .el-input__inner {
  border: $input-border-focus !important;
}
.el-select-dropdown__item {
  text-transform: capitalize;
}
.el-input__inner {
  border-color: $input-border-color;
}
.el-input__inner,
.Baseinput input {
  // text-transform: capitalize !important;
}
// input:focus {
// 	border: 1px solid #8fa7e1;
// 	outline: none;
// }

//created custome css for element ui
// used custom-elementUi-css under table then inside of custom-elementUi-css used datepicker, select option, step dropdown for whole project.
.custom-elementUi-css .el-date-editor .el-input__inner {
  height: 30px !important;
  font-size: 12px;
}

.custom-elementUi-css .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 120px !important;
}

.custom-elementUi-css .el-input__icon {
  line-height: 20px !important;
}
.custom-elementUi-css .el-select .el-input__inner {
  height: 30px;
  font-size: 12px;
  width: 55px;
}

.custom-elementUi-css .el-input__inner {
  border: none;
}

.custom-elementUi-css .el-input__inner:focus,
.custom-elementUi-css .el-select .el-input__inner:focus {
  border: none !important;
}

.custom-elementUi-css .el-input-number--mini {
  width: 90px;
}

// custom element ui pagination css
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #f7ba89;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #000;
}
.el-pagination .btn-next,
.el-pagination .btn-prev {
  border-radius: 50% !important;
}
.el-pager li {
  border-radius: 50% !important;
}
.el-loading-mask {
  z-index: 4 !important;
}
.v-modal {
  z-index: 5 !important;
}
.el-dialog__body {
  word-break: normal !important;
}
.cookies-confirmation {
  display: flex;
  justify-content: center;
  background: #fff;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  z-index: 100000000 !important;
  border-bottom: 1px solid #cbd6e2;
  border-top: 1px solid #cbd6e2;
  box-shadow: 0 1px 5px #eaf0f6;
  color: #33475b;
  font-weight: 400;
  text-align: center;
  font-size: 12px;
  line-height: 18px;
  padding: 15px;
  span {
    color: #0091ae;
    cursor: pointer;
  }

  .confirmation-btns {
    margin-left: 25px;
    span {
      color: #fff;
    }
    .accept-btn {
      border-color: #e29d5a;
      background-color: #e29d5a;
      min-width: 65px;
    }
    .decline-btn {
      background-color: #707070;
      border-color: #707070;
      color: #fff;
      min-width: 65px;
    }
  }
}

@media screen and (max-width: 768px) {
  .cookies-confirmation {
    display: block;
  }
  .confirmation-btns {
    margin-left: 0;
  }
}
button:focus {
  outline: 0 !important;
}
</style>
